import { Observable } from 'rxjs';
import { IMachineTotals } from 'app/models';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-department-totals',
  templateUrl: 'department.totals.component.html',
  styleUrls: ['department.totals.component.scss'],
})
export class DepartmentTotalsComponent {
  @Input()
  selectedDepartmentTotals$: Observable<IMachineTotals> | null = null;
}
